import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class reviewService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getReviewDataList = (params) => {
    return AxiosService.Get(`api/cam/srm/batches-list/`, {
      params: params,
    });
  };

  getBatchMetaData = (params) => {
    return AxiosService.Get(`api/cam/srm//template/batch/`, {
      params: params,
    });
  };

  getReviewAudit = (params) => {
    return AxiosService.Get(`api/cam/srm/manage/data/audit/`, {
      params: params,
    });
  };
  getReviewMenu = (params) => {
    return AxiosService.Get(
      `api/cam/srm/template/batch/${params.batch_id}/${params.unit_op_id}/`,
      {}
    );
  };

  uploadMediaFiles = (data) => {
    return AxiosService.Post(`api/cam/srm/upload_file/`, data, {
      ...this.getHeaders(),
    });
  };

  updateBatchData = (data) => {
    return AxiosService.Post(`api/cam/srm/edit/batch-meta-data/`, data, {
        ...this.getHeaders(),
    });
  };

  approveBatch = (data) => {
    return AxiosService.Post(`api/cam/srm/approve-batch-rows/`, data, {
      ...this.getHeaders(),
    });
  };

  uploadMedia = (params) => {
    return AxiosService.Post(`api/cam/srm/limits-list/`, {
      params: params,
    });
  };

  downloadTemplate = (params) => {
    return AxiosService.Get(`api/cam/srm/get-uop-template/`, {
      params: params,
    });
  };

  getSummaryList = (params) => {
    return AxiosService.Get(`api/cam/srm/list-ingestion-files/`, {
      params: params,
    });
  };

  approveMultiBatch = (params) => {
    return AxiosService.Post(`api/cam/srm/approve-batches-bulk/`,params);
  };
  
  getUserList = (params) => {
    return AxiosService.Get(`api/cam/srm/users-list/`, {
      params: params,
    });
  };

   downloadExcelTemplate = (params) => {
    return AxiosService.Get(`api/cam/pc/template-download/`, {
      params: params,
      responseType: "blob",
    });
  };
}
